






































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import AppAvatar from '~/components/partials/App/AppAvatar.vue';
import AppContentCardThumbnail from '~/components/partials/App/AppContentCardThumbnail.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useMatchMedia } from '~/composables/useMatchMedia';
import { THUMBNAIL_300, THUMBNAIL_250 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { sendGaEvent } from '~/utils/ga';
import { ArticleCard, ArticleCategory, EditorProfile } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppLink,
    AppAvatar,
    AppContentCardThumbnail,
  },
  props: {
    item: {
      type: Object as PropType<ArticleCard>,
      required: true,
    },
    authors: {
      type: Array as PropType<EditorProfile[]>,
      default: () => [],
    },
    categories: {
      type: Array as PropType<ArticleCategory[]>,
      default: () => [],
    },
  },
  setup(props) {
    const { isMobile } = useMatchMedia();
    const detailUrl = computed(() => url('ARTICLE_DETAIL', { permalink: props.item.permalink }));
    const author = computed(() => props.authors.find(({ id }) => id === props.item.authorId));
    const authorUrl = computed(() => author.value && url('ARTICLE_LIST_AUTHOR', { permalink: author.value.permalink }));
    const category = computed(() => props.categories.find(({ id }) => id === Number(props.item.categoryId)));
    const categoryUrl = computed(
      () => category.value && url('ARTICLE_LIST_CATEGORY', { permalink: category.value.permalink })
    );
    const publishedAt = computed(() => dayjs(props.item.publishedAt).tz('Asia/Tokyo').format('YYYY.M.D'));

    const thumbnailImageSp = computed(() =>
      props.item.thumbnailImageSp ? props.item.thumbnailImageSp + THUMBNAIL_250 : undefined
    );
    const thumbnailImagePc = computed(() =>
      props.item.thumbnailImagePc ? props.item.thumbnailImagePc + THUMBNAIL_300 : undefined
    );
    const mainImageSp = computed(() => (props.item.mainImageSp ? props.item.mainImageSp + THUMBNAIL_250 : undefined));
    const mainImagePc = computed(() => (props.item.mainImagePc ? props.item.mainImagePc + THUMBNAIL_300 : undefined));

    const onClickDetailLink = () => {
      sendGaEvent('ワインの読み物', detailUrl.value, props.item.title);
    };

    return {
      isMobile,
      thumbnailImageSp,
      thumbnailImagePc,
      mainImageSp,
      mainImagePc,
      detailUrl,
      author,
      authorUrl,
      category,
      categoryUrl,
      publishedAt,
      onClickDetailLink,
    };
  },
});
